import React from 'react';

const Loader = (props) => (
  <div style={{ padding: '10%', textAlign: 'center' }}>
    <i className="fa fa-circle-o-notch fa-spin fa-3x" />
  </div>
);

export default Loader;
